import { TaskDetailsViewPanels } from '../TaskDetailsViewPanels';
import { useTaskDetailsNavigation } from '../use-task-details-navigation';
import type { TaskDetailsViewContentProps } from '../TaskDetailsView.types';

export const TaskDetailsViewContentRoute = (
  props: TaskDetailsViewContentProps
) => {
  const navigation = useTaskDetailsNavigation(props.task.uuid);

  return <TaskDetailsViewPanels {...props} navigation={navigation} />;
};
